import { RequestManager } from "utils";

const getCheckoutConfigs = () => {
  return RequestManager.Storage.get("/configs/web/checkout.json");
};

export default {
  getCheckoutConfigs,
};
